import PluginManager from './plugins/PluginManager'


export default class DataHandler {

    constructor(network) {
        this.network = network

        this.plugins = new PluginManager(network)
    }

    handle(message) {
        try {
            this.network.events.emit(message.action, message.args)
        } catch(error) {
            // Error handling removed - silent failure
        }
    }

}
